import { render, staticRenderFns } from "./OrganisationMemberInvite.vue?vue&type=template&id=6372ac70&scoped=true"
import script from "./OrganisationMemberInvite.vue?vue&type=script&lang=js"
export * from "./OrganisationMemberInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372ac70",
  null
  
)

export default component.exports